import useAlias from '@alias';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { IconButton, Tooltip } from '@mui/material';
import React from 'react';
import { helpButtonStyles } from './styles';

const HelpButton: React.FC = () => {
  const alias = useAlias();

  return (
    <Tooltip
      title={alias(
        "This monitor displays only incidents configured with '[MaxCellT_Rack_Incident]' in the alert name. Configure alerts in the Alerts Config section to have them appear here.",
      )}
      placement='left'
      arrow
    >
      <IconButton
        size='small'
        sx={helpButtonStyles}
        aria-label={alias('Help information about incident monitoring')}
      >
        <HelpOutlineIcon fontSize='small' />
      </IconButton>
    </Tooltip>
  );
};

HelpButton.displayName = 'HelpButton';

export default HelpButton;
